export default "__VITE_ASSET__CL0Nss2J__"